import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AiServicePage from "./pages/AiServicePage";
import PageMetadata from "./components/PageMetadata";
import LanguageProvider from "./i18n/LanguageProvider";
import LegacyAiRedirect from "./components/LegacyAiRedirect";
import CatalogPage from "./pages/CatalogPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <ScrollToTop />
      <PageMetadata />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ai-photo-video" element={<AiServicePage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/en" element={<HomePage />} />
        <Route path="/en/catalog" element={<CatalogPage />} />
        <Route path="/en/ai-photo-video" element={<AiServicePage />} />
        <Route path="/jasa-foto-video-ai" element={<LegacyAiRedirect />} />
        <Route path="/en/jasa-foto-video-ai" element={<LegacyAiRedirect />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}
